import { render, staticRenderFns } from "./my_focus.vue?vue&type=template&id=6d8d1112&scoped=true&"
import script from "./my_focus.vue?vue&type=script&lang=js&"
export * from "./my_focus.vue?vue&type=script&lang=js&"
import style0 from "./my_focus.vue?vue&type=style&index=0&id=6d8d1112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8d1112",
  null
  
)

export default component.exports